import { render, staticRenderFns } from "./IcdItem.vue?vue&type=template&id=0bfd4508&scoped=true&"
import script from "./IcdItem.vue?vue&type=script&lang=js&"
export * from "./IcdItem.vue?vue&type=script&lang=js&"
import style0 from "./IcdItem.vue?vue&type=style&index=0&id=0bfd4508&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfd4508",
  null
  
)

export default component.exports